import { isInvoiceSummaryBucketFilterSelected } from '@finance-hub/domain/invoicing/blocs/utils/invoice-summary-bucket-filter-utils';
import { useInvoiceSummaryLoader } from '@finance-hub/domain/invoicing/blocs/loaders/use-invoice-summary-loader';
import { useUnpaidInvoiceFilterStore } from '@finance-hub/domain/invoicing/blocs/stores/use-unpaid-invoice-filter-store';

export const useSelectedBucketFilterLabel = (): string | null => {
  const selectedFilter = useUnpaidInvoiceFilterStore(
    (state) => state.selectedBucketFilter,
  );
  const { summary } = useInvoiceSummaryLoader();

  if (selectedFilter.kind === 'allInvoices' || !summary) {
    return null;
  }

  const selectedBucket = [
    ...summary.amountBuckets,
    ...summary.timeSeriesBuckets,
  ].find((bucket) =>
    isInvoiceSummaryBucketFilterSelected(bucket.filter, selectedFilter),
  );

  return selectedBucket?.label ?? null;
};
